import { render, staticRenderFns } from "./block-documents-status-and-send-date.vue?vue&type=template&id=5870a3f8&scoped=true&lang=pug"
import script from "./block-documents-status-and-send-date.vue?vue&type=script&lang=js"
export * from "./block-documents-status-and-send-date.vue?vue&type=script&lang=js"
import style0 from "./block-documents-status-and-send-date.vue?vue&type=style&index=0&id=5870a3f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5870a3f8",
  null
  
)

export default component.exports